import { createFileRoute, notFound, Outlet, redirect } from "@tanstack/react-router";
import { setTenantScope } from "@/api/client";
import { ALL_STORES, canonicalScope, defaultScope, looksLikeStoreId, rememberScope } from "@/lib/store-scope";

/**
 * Every app page is namespaced by store: `/{storeId}/…` or `/ALL/…`. The scope is checked
 * against the user's stores (the backend re-checks it on every request through X-Store-Id).
 * Stores the user can't access fall back to the default scope; old links without a scope
 * (`/opportunities/…`) are redirected by the routes in src/routes/<section>.$.tsx.
 */
export const Route = createFileRoute("/_authenticated/$store")({
  beforeLoad: ({ context: { me }, params, location }) => {
    const scope = canonicalScope(me, params.store);
    if (scope === null) {
      // A store this user can't access (revoked, other organization): same page, default scope.
      if (!looksLikeStoreId(params.store)) throw notFound();
      const rest = location.pathname.slice(params.store.length + 1);
      throw redirect({ href: `/${defaultScope(me)}${rest}${location.searchStr}`, replace: true });
    }
    if (scope !== params.store) {
      throw redirect({ href: `/${scope}${location.pathname.slice(params.store.length + 1)}${location.searchStr}`, replace: true });
    }
    // Requests from this tab are scoped to the URL's store, before any page loads data.
    setTenantScope({ organizationId: me.organization.id, storeId: scope });
    rememberScope(me, scope);
    return { scope, allStores: scope === ALL_STORES };
  },
  component: Outlet,
});
